import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      localStorage.removeItem("gemeinde_token");
      let data;
      try {
        ({ data } = await api.get("/auth/me"));
      } catch (error) {
        if (error.response?.status !== 401) throw error;
        await api.post("/auth/refresh");
        ({ data } = await api.get("/auth/me"));
      }
      setUser(data);
    } catch {
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: returning from OAuth callback — AuthCallback establishes the session first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const applyLogin = (data) => {
    localStorage.removeItem("gemeinde_token");
    setUser(data);
    setLoading(false);
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* ignore */
    }
    localStorage.removeItem("gemeinde_token");
    setUser(false);
  };

  const isAdmin = !!user && ["PLATFORM_ADMIN", "COMMUNITY_ADMIN", "MODERATOR"].includes(user.role);

  return (
    <AuthContext.Provider value={{ user: user || null, loading, checkAuth, applyLogin, logout, isAdmin, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
